
	import Dispatch from '../Dispatcher'
  import { withLatestFrom, map, tap, switchMap, mergeMap, share, catchError, filter, take, startWith  } from 'rxjs/operators';
import { combineLatest, merge, of, from } from 'rxjs';
import _ from 'lodash'
import { lights } from './staticLights'
import moment from 'moment'
import clock from './clock'

const parserTypes = {
  spiral: next => { return next.type + '(' + next.position + ', ' + next.width + ', ' + next.holdtime + ', ' + next.lightgroup + ', ' + next.reverse + ', ' + next.option + ')' },
  flash: next => { return next.type + '(' + next.position + ', ' + next.width + ', ' + next.lightgroup + ', ' + next.option + ')'},
  twinkle: next => { return 'loop(0, ' + parseInt(next.width/200) + ', ' + 200 + ') \n ' + next.type + '(' + next.position + ', ' + 150 + ', ' + next.lightgroup + ', ' + next.option + ') \n endloop'},
}

// const reverseParseTypes = {
//   spiral: next => {
//     return {
//       position: next[0], 
//       width: next[1],
//       holdtime: next[2], 
//       lightgroup: next[3], 
//       reverse: next[4], 
//       option: next[5] 
//     }
//   },
//   flash: next => {
//     return {
//       position: next[0], 
//       width: next[1],
//       lightgroup: next[2], 
//       option: next[3] 
//     }
//   },
//   twinkle: next => {
//     return {
//       position: next[0], 
//       width: next[1],
//       lightgroup: next[2], 
//       option: next[3] 
//     }
//   }
//   { return next.type + '(' + next.position + ', ' + next.width + ', ' + next.holdtime + ', ' + next.lightgroup + ', ' + next.reverse + ', ' + next.option + ')' },
//   flash: next => { return next.type + '(' + next.position + ', ' + next.width + ', ' + next.lightgroup + ', ' + next.option + ')'},
//   twinkle: next => { return 'loop(0, ' + parseInt(next.width/200) + ', ' + 200 + ') \n ' + next.type + '(' + next.position + ', ' + 150 + ', ' + next.lightgroup + ', ' + next.option + ') \n endloop'},
// }

// const reverseParse = (line) => {
//   const parse = reverseParseTypes[line.command](line)
// }


  const parseBranch = (results, command) => {
    // Parse inner commands of a group
    const inner = _.filter(results, result => result.index > command.index && result.index < command.end)
    const groups = _.filter(inner, result => result.command === 'loop').map(group => ({...group, end: _.find(inner, result => (result.command === 'endloop' && result.index > group.index)).index}))
    const nonGroup = _.filter(inner, result => groups.reduce((acc, next) => acc ? (result.index < next.index || result.index > next.end) ? true : false : false, true ))
    return [...groups.map(entry => ({...entry, children: parseBranch(inner, entry) })), ...nonGroup]
  }
  
  const parseTree = results => {
    // Get any grouping commands
    const groups = _.filter(results, result => result.command === 'loop').map(group => ({...group, end: _.find(results, result => (result.command === 'endloop' && result.index > group.index)).index}))
    // Find any commands not inside a group
    const nonGroup = _.filter(results, result => groups.reduce((acc, next) => acc ? (result.index < next.index || result.index > next.end) ? true : false : false, true ))
    // Create array of commands, with group commands adding children
    return [...groups.map(entry => ({...entry, children: parseBranch(results, entry) })), ...nonGroup]
  }
  
  const parseLines = (text) => {
    return _.filter(
      // Splits new lines
      text.split(/\r?\n/)
          // Removes all white space
          .map(line => line.replace(/\s/g,''))
          // Removes anything after //
          .map(line => line.split('//')[0])
          // Maps line index for debugging
          .map((line,index) => ({ index: index+1, value: line})), 
        // Removes any blank lines
        line => (line.value !== ""))
            // Maps line to variables and functions
            .map(line => parseFunction(line))
  }
  
  const parseFunction = (line) => {
    const parsedLine = line.value.toLowerCase().split('(')
    const command = parsedLine[0]
    const variables = parsedLine[1]?.replace(')', '')?.split(',')
    if (_.isNil(command)) {
      throw new Error ('Line ' + line.index + ': Missing Command')
    }
    if (_.isNil(variables) && (command !== 'endloop')) {
      throw new Error ('Line ' + line.index + ': Missing Variables')
    }
    return {
      command,
      variables,
      index: line.index,
    }
  }
  
  // var audio
  // Dispatch.getState('MultiSelect.song')
  //   .pipe(
  //     // Filter mutliselect keys for true
  //     map(multiSongs => _.filter(Object.keys(multiSongs).map(key => ({key, value: multiSongs[key]})), song => song.value)),
  //     //map(multiSongs => _.find(multiSongs, song => song)),
  //     tap(e => console.log("hiiiiii")),
  // tap(e => console.log(e)),
  //     map(filteredSongs => filteredSongs[0]),
  //     tap(e => console.log("hooooooooooo")),
  // // tap(e => console.log(e)),
  
  //   )
  //   .subscribe(song => {
  //     audio && audio.pause()
  //     //var audio = new Audio('https://s3.amazonaws.com/www.easttroylights.com/scripts/testsong.m4a');
  //     audio = new Audio(songs[song.key].path);
  //     audio.addEventListener('canplaythrough', () => Dispatch.nextState('audio.loaded', true));
  //     audio.load()
  //     Dispatch.nextState('audio.song', audio)
  //   })

  Dispatch.getState('view.visual')
    .pipe(
      switchMap(visual => visual ? Dispatch.getState('layers')
        .pipe(
          map(e => e.reduce((acc,next) => {
            return acc + '\n' + parserTypes[next.type](next)
          }, '')),
        )
        :
        Dispatch.getState('writtenCode')
          .pipe(
          )
      )
    )
    .subscribe(e => Dispatch.nextState('parsedCode', e))
  
  const start$ = merge(
    combineLatest(Dispatch.getAction('start')
      .pipe(
        switchMap(e => from([true,false])
          .pipe(
            
          )
        )
      ),
      Dispatch.getState('view.playing'),
      Dispatch.getAction('scrubClock').pipe(startWith(0))
    )
      .pipe(
        filter(e => e[0] || e[1]),
        withLatestFrom(Dispatch.getState('parsedCode')),
        map(e => e[1])
        )
    // of(startScript)
  )
  .pipe(
    switchMap(e => of(e)
      .pipe(
          // Parse commands from script text
          map(script => parseLines(script)),
          // Report error
          catchError(e => {
            Dispatch.nextAction('error', e.message)
          }),
          // Get commands in heirachical order
          map(e => parseTree(e)),
          // Execute commands
          map(e => (_.flatten([...e.map(line => _.flatten(callCommand(line.index, line.command, line.variables, line.children)))]))),
          map(e => e.reduce((acc, next) => {
            const accumulated = [...acc]
            accumulated[next.id] = {...next, states: [...acc[next.id]?.states ?? [], next.on]}
            return accumulated
          }, [])),
          map(lights => _.filter(lights, light => !_.isNil(light))),
          catchError(e => {
            Dispatch.nextAction('error', e.message)
          }),
      )
    ),
    switchMap(script => of(1)
      .pipe(
        map(e => moment()),
        mergeMap(e => Dispatch.getState('audio.song')
          .pipe(
            switchMap(song => Dispatch.getState('audio.loaded').pipe(
                filter(e => e === true),
                take(1)
              )
              .pipe(
                withLatestFrom(Dispatch.getState('view.elapsed'), Dispatch.getState('audio.song')),
                tap(([,startTime, audio]) => {
                  audio.currentTime = startTime/1000
                  audio.play()
                }),
              )
            ),
            map(e => script)
          )
        )
      )
    ),
    tap(e => Dispatch.nextState('view.playing', true)),
    share()
  )
  //.subscribe(e => console.log(e))
    
  export const render = combineLatest(clock, start$)
    .pipe(
      map(([time, lights]) => lights.map(light => {
        const on = light.states.reduce((acc,next) => {
          const state = next(time)
          return acc ? acc : state
        }, false)
        return {...light, on }
      })),
    )
  
  const flashLight = (startTime, holdTime, lightArray) => {
    return lightArray.map(light => {
      const endTime = startTime + holdTime
      //const endTime = moment(startTime).add(holdTime)
      //console.log(endTime)
      return {
        id: light, 
        on: ((time) => ((time > startTime) && (time < endTime)) ? true : false),
      }
    })
  }
  
  export const spiral = (startTime, runTime, holdTime, group, reverse, custom) => {
    const cleanedStartTime = parseInt(startTime)
    const cleanedRunTime = parseInt(runTime)
    const cleanedHoldTime = parseInt(holdTime)
    const cleanedReverse = (reverse === 'true') ? true : false
  
    const currentLights = _.filter(lights.map(light => ({id: light.id, group: _.find(light.groups, entry => entry.id === group)})), mappedLight => mappedLight.group)
    const uniqueIndexes = _.uniqBy(currentLights, light => light.group.index)
    const totalTime = cleanedRunTime
    // Double up indexes 
    const timeBetweenLights = totalTime/(uniqueIndexes.length)
  
    let finalLights = currentLights
    if (custom === 'even'){
      finalLights = _.filter(currentLights, light => light.group.index % 2 === 0)
    }
    else if (custom === 'odd') {
      finalLights = _.filter(currentLights, light => light.group.index % 2 === 1)
    }
  
    return _.flatten(finalLights.map(light => 
      flashLight(cleanedStartTime + (cleanedReverse ? ((uniqueIndexes.length * timeBetweenLights) - (light.group.index * timeBetweenLights)) : (light.group.index * timeBetweenLights)), cleanedHoldTime, [light.id]))
    )}
  
  export function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }
  
  export const twinkle = (startTime, holdTime, group) => {
    const cleanedStartTime = parseInt(startTime)
    const cleanedHoldTime = parseInt(holdTime)
    const currentLights = _.filter(lights.map(light => ({id: light.id, group: _.find(light.groups, entry => entry.id === group)})), mappedLight => mappedLight.group)
    return flashLight(cleanedStartTime, cleanedHoldTime, [currentLights.map(light => light.id)[getRandomInt(currentLights.length)]])
    
  }
  
  export const flash = (startTime, holdTime, group, special) => {
    const cleanedStartTime = parseInt(startTime)
    const cleanedHoldTime = parseInt(holdTime)
  
    const currentLights = _.filter(lights.map(light => ({id: light.id, group: _.find(light.groups, entry => entry.id === group)})), mappedLight => mappedLight.group)
  
    let finalLights = currentLights
    if (special === 'even'){
      finalLights = _.filter(currentLights, light => light.group.index % 2 === 0)
    }
    else if (special === 'odd') {
      finalLights = _.filter(currentLights, light => light.group.index % 2 === 1)
    }
  
    return flashLight(cleanedStartTime, cleanedHoldTime, finalLights.map(light => light.id))
  }
  
  
  export const group = (startTime, children) => {
    return merge(
      ...children.map(line => {
        const variables = [...line.variables] 
        variables[0] = parseInt(line.variables[0]) + parseInt(startTime)
        return callCommand(line.index, line.command, variables, line.children)
      })
    )
  }
  
  export const loop = (startTime, quantity, delayBetween, children) => {
    const commands = _.flatten([...Array(parseInt(quantity))].map((r, index) => children.map(line => {
      const variables = [...line.variables] 
      variables[0] = parseInt(line.variables[0]) + parseInt(startTime) + (index*parseInt(delayBetween))
      return callCommand(line.index, line.command, variables, line.children)
    })))
    return commands
  }
  
  const lightCommands = {
    spiral,
    flash,
    twinkle,
    //group,
    loop,
  }
  
  export const callCommand = (line, command, params, children) => {
    const func = lightCommands[command]
    if (_.isNil(func)) {
      throw new Error('Line ' + line + ': Function does not exist')
    }
    else {
      return func(...params, children)
    }
  }